import xhrService from '../xhrService';

const offlineApi = {
  
  download: (projectId,inspectionTemplateId) => {
    return xhrService.post(`/api/offline/`, { projectIds: [projectId], inspectionTemplateId })
    .then(response => response.data)
    .catch((error) => {
      // No `response` on network-level failures (connection refused, timeout,
      // CORS) — destructuring it there masks the real error with a TypeError.
      throw new Error(error?.response?.data?.message || error.message);
    });
  },

  delete: (projectId) => {
    return xhrService.delete(`/api/offline/${projectId}`)
    .then(response => response.data)
    .catch((error) => {
      throw new Error(error?.response?.data?.message || error.message);
    });
  },
  getOfflineByUser: (userId) => {
    return xhrService.get(`/api/offline/user/${userId}`)
      .then(response => response.data)
      .catch((error) => {
        throw new Error(error?.response?.data?.message || error.message);
      });
  }

};

export default offlineApi;
export { offlineApi };
